import React from "react";

import { ModalAdapterProps, ModalTypes } from "constants/navigation";
import GlobalBusinessCreateDialog from "components/Business/GlobalBusinessCreate/Modal";
import { useModalAdapter } from "hooks";

function GlobalBusinessCreateModalAdapter(
  props: ModalAdapterProps,
): React.JSX.Element {
  const handleClose = useModalAdapter(
    ModalTypes.GlobalBusinessCreate,
    props,
  )[2];

  return <GlobalBusinessCreateDialog handleClose={handleClose} />;
}

export default GlobalBusinessCreateModalAdapter;
